import axios from "axios";

function mapListItem(item) {
  return {
    id: item.id,
    grCode: item.grNo || "",
    poRefCode: item.refDocNo || "",
    vendorCode: item.vendorNo || "",
    vendorName: item.vendorName || "",
    branchName: item.branch?.name || "",
    createdAt: item.creationDt || "",
    status: item.status || "",
    items: [],
  };
}

function mapDetailItem(item) {
  return {
    id: item.id,
    grCode: item.grNo || "",
    poRefCode: item.refDocNo || "",
    vendorCode: item.vendorNo || "",
    vendorName: item.vendorName || "",
    branchName: item.branch?.name || "",
    createdAt: item.creationDt || "",
    status: item.status || "",
    items: (item.goodReceiveProducts || []).map(p => ({
      productId: p.productId,
      productCode: p.product?.no || "",
      productNameMain: p.product?.description || "",
      quantity: p.qtyUom,
      uomId: p.uomId,
      uomName: p.uom?.description || p.product?.baseUom?.description || "",
      uom: p.uom || null,
      totalPrice: p.totalCost || 0,
      lotNumber: p.lotNo || "",
      expiredDt: p.expiredDt || null,
    })),
  };
}

const moduleGoodsReceive = {
  namespaced: true,
  state: {
    goodsReceiveList: [],
  },
  mutations: {
    setGoodsReceiveList(state, data) {
      state.goodsReceiveList = data;
    },
  },
  actions: {
    async fetchGoodsReceiveList({ commit }, { clinicUrl, branchUrl }) {
      try {
        const res = await axios.get(
          `/api/goodreceive/${clinicUrl}/${branchUrl}`
        );
        const mappedData = (res.data.data || []).map(mapListItem);
        commit("setGoodsReceiveList", mappedData);
        return mappedData;
      } catch (err) {
        console.error("fetchGoodsReceiveList failed", err);
        throw err;
      }
    },
    async fetchGoodsReceiveById(_, { clinicUrl, branchUrl, id }) {
      try {
        const res = await axios.get(
          `/api/goodreceive/${clinicUrl}/${branchUrl}/${id}`
        );
        return mapDetailItem(res.data.data);
      } catch (err) {
        console.error("fetchGoodsReceiveById failed", err);
        throw err;
      }
    },
    createGoodsReceive(_, payload) {
      const apiBody = {
        vendorNo: payload.body.vendorCode,
        vendorName: payload.body.vendorName,
        refDocNo: payload.body.poRefCode,
        goodReceiveProducts: payload.body.items.map(item => ({
          productId: item.productId,
          qtyUom: item.quantity,
          uomId: item.uomId,
          totalCost: item.totalPrice,
          lotNo: item.lotNumber || "",
          expiredDt: item.expiredDt || null,
        })),
      };
      return axios
        .post(
          `/api/goodreceive/${payload.clinicUrl}/${payload.branchUrl}`,
          apiBody,
          { skipGlobalErrorHandler: true }
        )
        .then(res => res)
        .catch(err => {
          throw err;
        });
    },
    updateGoodsReceive(_, payload) {
      const apiBody = {
        vendorNo: payload.body.vendorCode,
        vendorName: payload.body.vendorName,
        refDocNo: payload.body.poRefCode,
        goodReceiveProducts: payload.body.items.map(item => ({
          productId: item.productId,
          qtyUom: item.quantity,
          uomId: item.uomId,
          totalCost: item.totalPrice,
          lotNo: item.lotNumber || "",
          expiredDt: item.expiredDt || null,
        })),
      };
      return axios
        .put(
          `/api/goodreceive/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`,
          apiBody,
          { skipGlobalErrorHandler: true }
        )
        .then(res => res)
        .catch(err => {
          throw err;
        });
    },
    deleteGoodsReceive(_, payload) {
      return axios
        .delete(
          `/api/goodreceive/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`,
          { skipGlobalErrorHandler: true }
        )
        .then(res => res)
        .catch(err => {
          throw err;
        });
    },
  },
  getters: {
    getGoodsReceiveList: state => {
      return state.goodsReceiveList;
    },
  },
};

export default moduleGoodsReceive;
